let baitDiv = document.createElement('div');
baitDiv.innerHTML = '';
baitDiv.className = 'AdsBox';
baitDiv.style.visibility = 'unset';
baitDiv.style.display = 'none';
document.body.appendChild(baitDiv);